import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions = {
    getServiceRequestJobsByServiceRequest(context, payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.serviceRequestJobs}/service-request/${payload}`).then((res) => {
                if (res.status === 200) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

}

export default actions;